import type { NavigateFunction } from 'react-router-dom';
import { RouterPaths } from 'src/components/Router/Router.constants';
import { CURRENT_FUNNEL_ID_STORAGE_KEY } from 'src/pages/Pipe/Pipe.constants';
import { tContent, tContentFunnelMove } from 'src/components/Chat/Chat.types';

/**
 * Read the funnel-move refs off an event's content regardless of delivery
 * path (RET-1311): bff-web's REST shape wraps them as `funnelMove`, while the
 * WebSocket `chat_event.inserted` echo relays chats-service's `funnel_move`
 * verbatim. Never read one key directly — always through here.
 */
export function getContentFunnelMove(
  content: tContent | null | undefined,
): tContentFunnelMove | null {
  return content?.funnelMove ?? content?.funnel_move ?? null;
}

/**
 * Deep-link mechanism shared by the live FunnelMoveBubble and the persisted
 * NoteBubble rendering: the Pipe page selects its funnel from this
 * localStorage key on mount (ahooks useLocalStorageState → JSON-serialized).
 * Seed it, then route to the funnels page so the destination funnel is
 * already selected when the operator lands. Best-effort write — a quota /
 * access failure just means the Pipe page opens on its default funnel.
 */
export function openFunnelBoard(navigate: NavigateFunction, funnelUuid: string) {
  try {
    localStorage.setItem(
      CURRENT_FUNNEL_ID_STORAGE_KEY,
      JSON.stringify(funnelUuid),
    );
  } catch {
    // no-op: navigation still lands the operator on the funnels page
  }
  navigate(RouterPaths.funnels);
}
